import Box from '@mui/joy/Box';
import Checkbox  from '@mui/joy/Checkbox';
import Sheet from '@mui/joy/Sheet';
import { useEffect, useState } from 'react';
import { useContext } from 'react';
import { ContextFromSelections,FetchedDataContext } from './Context';
import FormControl from '@mui/joy/FormControl';
import {Typography} from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import Skeleton from '@mui/material/Skeleton';












export default function ColorsCheckbox() {
 

  function getContrastColor(bgColor) {
    const r = parseInt(bgColor.slice(1, 3), 16);
    const g = parseInt(bgColor.slice(3, 5), 16);
    const b = parseInt(bgColor.slice(5, 7), 16);                                                          
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 128 ? '#000000' : '#FFFFFF';
  }

  const FetchedData = useContext(FetchedDataContext);
  const [selectedData,setSelectedData] = useContext(ContextFromSelections)

  const [selectedColor, setSelectedColor] = useState(selectedData.ribbonColor);
  const [RibbonColors, setRibbonColors] = useState([])
  const [RibbonColorCode,setRibbonColorCode] = useState(selectedData.ribbonColorCode)

  useEffect(() => {
    setRibbonColors(FetchedData.get("fetchedRibbonColors"))
  },[FetchedData]);

  
  useEffect(() => {
    setSelectedData((data) =>({
      ...data,
      ribbonColorCode: RibbonColorCode,
      ribbonColor: selectedColor
    }))},[selectedColor,RibbonColorCode])
  
  
  const handleCheckboxChange = (color) => {
    setSelectedColor(color.color_name === selectedColor ? null : color.color_name);
    setRibbonColorCode(color.color_name === selectedColor ?  null : color.color_code)
  }

  return (
    !RibbonColors  ? (
    <>
  <Skeleton animation="wave" sx={{ width: "100%", bgcolor: "#2c2d48" }} />  
  <Skeleton animation="wave" sx={{ width: "100%", bgcolor: "#4b3f5b" }} />  
  <Skeleton animation="wave" sx={{ width: "100%", bgcolor: "#6a4f6c" }} />  
  <Skeleton animation="wave" sx={{ width: "100%", bgcolor: "#80667f" }} /> 
  <Skeleton animation="wave" sx={{ width: "100%", bgcolor: "#968d72" }} />  
  <Skeleton animation="wave" sx={{ width: "100%", bgcolor: "#bba864" }} />  
  <Skeleton animation="wave" sx={{ width: "100%", bgcolor: "#d6c57c" }} />  
  <Skeleton animation="wave" sx={{ width: "100%", bgcolor: "#f2e7a5" }} /> 

    </>
  )
    
    
    :
      <Box>
      <FormControl>
          <Typography
          fontSize={12} 
          sx={{
            margin: {sm: "auto", xs: "auto",},
            // marginLeft: {md: '0'}
        }}
        >
          Color
        </Typography>
      </FormControl>
      <Box sx={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: "center",
        gap: {xs: 1.2, md: 1},
        paddingBottom: 5,
        // border: "1px solid blue"


      }}>
      
      
        {RibbonColors.map((color,index) => (
          
              <Checkbox
                key={index}
                variant='plain'
                disableIcon
                checked={color.color_name === selectedColor}
                onClick={() => handleCheckboxChange(color)}
                
                label={
                   <Sheet
                      // key={index}
                      variant='outlined'
                      sx={{
                        display: 'flex',
                        flexDirection: "column",
                        width: {md: 65  , xs: 50},
                        height:{md: 30, xs: 30},
                        borderRadius: '5px',
                        backgroundColor: color.color_code,
                    }}
            >
            <CheckRoundedIcon  fontSize='9' sx={{color: getContrastColor(color.color_code) ,margin: "auto", display: color.color_name === selectedColor ? "flex" : "none"}}/> 
            <Typography key={index} margin="auto"  color={ getContrastColor(color.color_code)} fontFamily="Inter" fontWeight={300} fontSize={{md: 8, xs: 6.5}}>{color.color_name}</Typography>
              
            </Sheet>
                    
                }

              />
        
        ))}
      </Box>
      </Box> 
    
      
  );
}


